"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function throttleUsingRaf(cb) {
    var rAfTimeout = null;
    return function () {
        if (rAfTimeout) {
            window.cancelAnimationFrame(rAfTimeout);
        }
        rAfTimeout = window.requestAnimationFrame(function () {
            cb();
        });
    };
}
exports.default = throttleUsingRaf;
